import {MenuOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import {useEffect, useState} from 'react';
import {NavLink} from 'react-router-dom';

import logo from '../../assets/Images/logo change.png';

import {DrawerComponent} from './DrawerComponent';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const showDrawer = () => setOpen(true);

  const closeDrawer = () => setOpen(false);
  
  //useeffect to check scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    {name: 'Home', path: '/'},
    {name: 'About', path: '/about'},
    {name: 'Products', path: '/products'},
    {name: 'Our Process', path: '/ourProcess'},
    {name: 'Gallery', path: '/gallery'},
    {name: 'Careers', path: '/careers'},
    // {name: 'Channel Partners', path: '/channel'},
  ];

  return (
    <div className={'max-w-7xl'}>
      <nav
        className={`fixed z-50 w-full bg-white font-serif text-black transition-all duration-300
      ${isScrolled ? 'py-2 shadow-md' : 'py-4'} px-4 md:px-8 lg:px-20`}
      >
        <div className={'max-w-7xl mx-auto flex items-center justify-between w-full'}>
          <NavLink to={'/'} className={'flex-shrink-0'}>
            <img
              src={logo}
              alt={'Logo'}
              className={`transition-all duration-300 ${
                isScrolled ? 'w-[150px] h-6' : 'w-[160px] h-10'
              }`}
            />
            
          </NavLink>

          {/* Desktop Menu */}
          <div className={'hidden  lg:flex items-center gap-10'}>
            {navLinks.map((link, index) => (
              <NavLink
                key={index}
                to={link.path}
                className={({isActive}) =>
                  `relative ${isActive ? 'after:w-2/3' : 'after:w-0'}
                  after:absolute after:left-0 after:bottom-0 after:h-[1.3px] after:bg-primary-800 
                  after:transition-all after:duration-300 hover:after:w-2/3`
                }
              >
                <span className={`transition-all duration-300 ${isScrolled ? 'text-base' : 'text-lg'}`}>
                  {link.name}
                </span>
              </NavLink>
            ))}
            <NavLink to={'/contact-us'}>
              <Button
                type={'primary'}
                className={`!bg-[#357851] !text-white font-serif transition-all duration-300
              ${isScrolled ? 'h-6 text-sm px-3' : 'h-7 text-base px-4'}`}
              >
              Contact Us
              </Button>
            </NavLink>
          </div>

          {/* Mobile Menu Button */}
          <div className={'lg:hidden flex items-center'}>
            <Button
              type={'text'}
              className={`transition-all duration-300 ${isScrolled ? 'h-12' : 'h-16'}`}
              icon={<MenuOutlined style={{fontSize: isScrolled ? '20px' : '24px', color: '#357851', fontWeight:'bold'}} />}
              onClick={showDrawer}
            />
          </div>
        </div>
        {/* Mobile Drawer */}
        <DrawerComponent open={open} closeDrawer={closeDrawer} />
      </nav>
    </div>
  );
};

export default Navbar;
